module.exports = __webpack_public_path__ + "img/WasSuchtSie.55535b63.jpg";